import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import * as WEBSITE_API from '../../constants/api/website-api.constants';
import { IEventTitleAndDescription, IPassportSettingsConfigurationDAO, IPassportSettingsConfigurationDTO } from '../passport-settings-configuration.dao';
import { IEventRequestParams } from '../shared.dto';

class PassportSettingsConfigurationDAO extends IPassportSettingsConfigurationDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getPassportSettingsConfiguration(params: IEventRequestParams): Promise<IPassportSettingsConfigurationDTO> {
        const response = await this.apiClient.get<IPassportSettingsConfigurationDTO>(WEBSITE_API.UPDATE_PASSPORT_SETTINGS_URL, params);
        return response.parsedResponse;
    }

    public async updatePassportSettingsConfiguration(
        params: IEventRequestParams , passportConfigurationConfiguration: IPassportSettingsConfigurationDTO
    ): Promise<IPassportSettingsConfigurationDTO> {
        const response = await this.apiClient.put<IPassportSettingsConfigurationDTO>(WEBSITE_API.UPDATE_PASSPORT_SETTINGS_URL, {
            ...params,
            ...passportConfigurationConfiguration
        });

        return response.parsedResponse;
    }

    public async getPassportTitleConfiguration(params: IEventRequestParams): Promise<IEventTitleAndDescription> {
        const response = await this.apiClient.get<IEventTitleAndDescription>(WEBSITE_API.GET_PASSPORT_TITLE_SETTINGS_URL, params);
        return response.parsedResponse;
    }

    public async editPassportTitleConfiguration(params: IEventRequestParams, data: IEventTitleAndDescription): Promise<IEventTitleAndDescription> {
        const response = await this.apiClient.put<IEventTitleAndDescription>(WEBSITE_API.UPDATE_PASSPORT_TITLE_SETTINGS_URL, {
            ...params,
            ...data
        });
        return response.parsedResponse;
    }

}

export { PassportSettingsConfigurationDAO };